import { useLang } from "../../context/LanguageContext";
import { images, unitImages } from "../../lib/api";

// Room imagery — distinct shots per room type
//  0: Zirben Chalet Schlafzimmer
//  1: Landhaus Schlafzimmer
//  2: Landhaus Küche
//  3: Landhaus Kaminzimmer
const photos = [
  images.bedroom1,
  unitImages.landhaus.gallery[5],
  unitImages.landhaus.gallery[2],
  unitImages.landhaus.gallery[8],
];

export default function Rooms() {
  const { t } = useLang();
  return (
    <section data-testid="rooms-section" className="section-pad bg-[hsl(var(--cream))]">
      <div className="container-x">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16 items-end">
          <div className="lg:col-span-7">
            <div className="overline mb-5">{t.rooms.eyebrow}</div>
            <h2 className="font-serif font-light text-4xl sm:text-5xl md:text-6xl leading-[1.02] tracking-tight text-[hsl(var(--foreground))] whitespace-pre-line">
              {t.rooms.title}
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12">
          {t.rooms.list.map((r, i) => (
            <div key={r.name} data-testid={`room-card-${i}`} className="group">
              <div className="aspect-[4/3] overflow-hidden bg-[hsl(var(--muted))]">
                <img src={photos[i]} alt={r.name} className="w-full h-full object-cover gallery-img" loading="lazy" />
              </div>
              <div className="mt-6 flex items-baseline gap-4">
                <div className="font-serif text-3xl text-[hsl(var(--accent))]">0{i + 1}</div>
                <h3 className="font-serif text-2xl text-[hsl(var(--foreground))]">{r.name}</h3>
              </div>
              <p className="mt-3 text-[hsl(var(--foreground))]/85 leading-relaxed max-w-md">{r.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
